module.exports = __webpack_public_path__ + "static/scale-model-of-market-catacombs-in-indianapolis-indiana-b8eb4afcc21b120ae0672b0bc58ff4b9.png";